import { IServersFilterStore } from './serversFilter.interface';

export const serversFilterInitialState: IServersFilterStore = {};
